import { createBrowserRouter, RouteObject } from "react-router-dom";
import { HOME } from "./configs/path";
import Home from "./pages/home";
import NotFound from "./pages/NotFound";

const routes: RouteObject[] = [
  {
    path: HOME,
    element: <Home />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

const router = createBrowserRouter(routes);

export default router;
